import {ChangeDetectorRef, inject, Pipe, PipeTransform} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {StoredIndustry, VocabularyKind, VocabularyService} from '../services/vocabulary.service';
import {BilingualSkill} from './model/vocabulary-name';

/** Wie der TranslatePipe unrein: der Name wechselt mit der Sprache und sobald die zentrale Liste da ist. */
@Pipe({name: 'vocabulary', standalone: true, pure: false})
export class VocabularyPipe implements PipeTransform {
  private readonly vocabulary = inject(VocabularyService);

  constructor() {
    const cdr = inject(ChangeDetectorRef);
    this.vocabulary.changes$.pipe(takeUntilDestroyed()).subscribe(() => cdr.markForCheck());
  }

  transform(value: StoredIndustry | BilingualSkill | null | undefined, kind: VocabularyKind): string {
    return this.vocabulary.display(value, kind);
  }
}
